import deadline from "app/utils/deadline";
import ErrorReport from "app/utils/error-report";
import Log from "app/utils/log";
import BvpRegUiClient from "app/lib/BvpRegUiClient";

const log = new Log("FenceService");
const TIMEOUT = 500; //ms

const SubscriptionService = {
    getSubscriberStatus() {
        return deadline(TIMEOUT, getFenceSubscriberStatus())
            .catch(error => {
                ErrorReport.recordGenericError(log, "Error getting fence subscriber status", error);
                return null;
            });
    }
};

function getFenceSubscriberStatus() {
    return new Promise((resolve) => {
        const regUiClient = BvpRegUiClient.getAndInitializeRegUiClient();
        if (!regUiClient) {
            return resolve(null);
        }

        regUiClient.onUserInfoReady(() => {
            const isTerminalUser = regUiClient.isTerminalSubscriber();
            const isSubscriber = regUiClient.isBBGSubscriber();
            const subscriberStatus = isTerminalUser ? "term" : (isSubscriber ? "yes" : "no");

            return resolve(subscriberStatus);
        });
    });
}

export default SubscriptionService;
